import { SimpleCenterLayout } from "@mnk/frontend/components/layouts/SimpleCenterLayout";
import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { setToken } from "@mnk/frontend/lib/auth";
import { trpc } from "@mnk/frontend/lib/trpc";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export const Login = () => {
  const loginMutation = trpc.login.useMutation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");

  return (
    <SimpleCenterLayout>
      <h2 className="text-xl font-bold text-center">ログイン</h2>
      <div className="flex flex-col gap-2 my-4 px-2">
        <label htmlFor="email" className="text-sm text-gray-500">
          メールアドレス
        </label>
        <input
          id="email"
          type="email"
          className="border border-gray-300 rounded-md p-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-2 my-4 px-2">
        <label htmlFor="password" className="text-sm text-gray-500">
          パスワード
        </label>
        <input
          id="password"
          type="password"
          className="border border-gray-300 rounded-md p-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      {error && <p className="text-sm text-red-500 text-center">{error}</p>}

      <PrimaryButton
        onClick={async (e) => {
          e.preventDefault();
          try {
            setProcessing(true);
            const result = await loginMutation.mutateAsync({ email, password });
            setToken(result.token);
            navigate(redirect || "/");
          } catch (error) {
            setError("ログインに失敗しました");
          } finally {
            setProcessing(false);
          }
        }}
        className="mt-8 w-full"
        disabled={processing}
      >
        ログイン
      </PrimaryButton>

      <p className="text-sm mt-4 text-gray-500 text-center">
        <Link to="/password-forgot">パスワードを忘れた方はこちら</Link>
      </p>
    </SimpleCenterLayout>
  );
};
